// 純粋ロジック層。DOM / Shopify API 非依存。
// 重量はグラム単位で扱う（Shopify variant.weight は単位設定に依存するため、
// 呼び出し側で必ずグラムに変換してから渡すこと）。
//
// クリックポストの規格上限は 1kg だが、厚さ 3cm の制約上、
// 実運用では金属/液体を含まない一般商品は限られた重量が現実的上限。
// MIYAGEN 自主運用ルールとして CLICKPOST 上限を 240g に設定（2026-05-21）。

export const CLICKPOST_LIMIT_GRAMS = 240;
export const TAKKYUBIN_LIMIT_GRAMS = 30000;

export const SHIPPING_MODES = Object.freeze({
  CLICKPOST: 'clickpost',
  TAKKYUBIN: 'takkyubin',
  OVERSIZE: 'oversize',
});

const MODE_DEFS = {
  [SHIPPING_MODES.CLICKPOST]: { id: SHIPPING_MODES.CLICKPOST, limitGrams: CLICKPOST_LIMIT_GRAMS, priceLabel: '350円' },
  [SHIPPING_MODES.TAKKYUBIN]: { id: SHIPPING_MODES.TAKKYUBIN, limitGrams: TAKKYUBIN_LIMIT_GRAMS, priceLabel: '¥800〜' },
  [SHIPPING_MODES.OVERSIZE]: { id: SHIPPING_MODES.OVERSIZE, limitGrams: Infinity, priceLabel: '要相談' },
};

export function totalWeight(items) {
  return items.reduce((sum, item) => {
    if (typeof item.weight !== 'number') return sum;
    return sum + item.weight * (item.quantity || 1);
  }, 0);
}

export function determineShippingMode(grams) {
  // Shopify 配送設定の「0〜240g」は 240g 未満(240g ちょうどはチェックアウトで宅急便のみ)
  if (grams < CLICKPOST_LIMIT_GRAMS) return MODE_DEFS[SHIPPING_MODES.CLICKPOST];
  if (grams <= TAKKYUBIN_LIMIT_GRAMS) return MODE_DEFS[SHIPPING_MODES.TAKKYUBIN];
  return MODE_DEFS[SHIPPING_MODES.OVERSIZE];
}

export function remainingCapacity(grams, mode) {
  if (!mode || typeof mode.limitGrams !== 'number') {
    throw new TypeError('remainingCapacity: mode.limitGrams must be a number');
  }
  const limit = mode.limitGrams;
  const remainingGrams = Math.max(0, limit - grams);
  const percentUsed = limit === Infinity ? 0 : Math.round((grams / limit) * 100);
  const percentRemaining = limit === Infinity ? 100 : Math.max(0, 100 - percentUsed);
  return { remainingGrams, percentUsed, percentRemaining };
}

export function filterRecommendations(candidates, remainingGrams, options = {}) {
  const alreadyInCart = new Set(options.alreadyInCart || []);
  const limit = options.limit ?? Infinity;
  const filtered = candidates.filter((c) => {
    if (alreadyInCart.has(c.id)) return false;
    if (typeof c.weight !== 'number') return false;
    return c.weight < remainingGrams;
  });
  return filtered.slice(0, limit);
}
/* cache bust 1779324751 */
/* force push 1779324812762010000 */
